import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Header({ logo, menuItems }) {
   const headerConfig = {
    logo,
    brand: 'Aspire Homes',
    menuItems: [
      { name: 'Home', link: '/', onClick: () => navigate('/') },
      { name: 'About', link: '/aboutus', onClick: () => navigate('/aboutus') },
      {
        name: 'Services',
        link: '/gallery',
        onClick: () => navigate('/services'),
        children: [
          {
            name: 'Custom Build',
            link: '/gallery/custom-built',
            onClick: () => navigate('/custom')
          },
          {
            name: 'Home Designs',
            link: '/gallery/home-design',
            onClick: () =>  navigate('/home')
          },
          {
            name: 'Knock Down Rebuilt',
            link: '/gallery/knockdown-rebuilt',
            onClick: () =>  navigate('/know')
          },
          // {
          //   name: 'Townhouses',
          //   link: '/gallery/townhouses',
          //    onClick: () =>  navigate('/town')
          // },
          {
            name: 'Current Projects',
            link: '/gallery/',
             onClick: () =>  navigate('/gallery')
          }
        ]
      },
      { name: 'Contact', link: '/contact', onClick: () => navigate('/contact') }
    ]
  };

  const [open, setOpen] = useState(false);                                                               
    const navigate = useNavigate();

  const handleClick = (link) => {
    setOpen(false); // close menu on click

    if (link.startsWith("#")) {
      // Smooth scroll to section on the same page
      const element = document.getElementById(link.replace("#", ""));
      if (element) element.scrollIntoView({ behavior: "smooth" });
    } else {
      // Navigate to another route if link is not a hash
      navigate(link);
    }
  };


  return (
    <header className="navbar-container">
      <img className="logo" src={headerConfig.logo} alt="Logo"  onClick={() => navigate("/")} />
      <button className="navbar-btn"  onClick={() => navigate("/contact")} >Enquire Now</button>

      <div className="hamburger" onClick={() => setOpen(!open)}>
        <span></span>
        <span></span>
        <span></span>
      </div>

   <ul className={`navbar-menu ${open ? "active" : ""}`}>
  {headerConfig.menuItems.map((item, index) => (
    <li key={index} className="nav-item">
      {/* Main menu link */}
      <a
        href={item.link}
        onClick={(e) => {
          e.preventDefault();
          setOpen(false); // close mobile menu
          item.onClick && item.onClick();
        }}
      >
        {item.name}
      </a>

      {/* Submenu, if children exist */}
      {item.children && (
        <ul className="submenu">
          {item.children.map((subItem, i) => (
            <li key={i}>
              <a
                href={subItem.link}
                onClick={(e) => {
                  e.preventDefault();
                  setOpen(false); // close mobile menu
                  subItem.onClick && subItem.onClick();
                }}
              >
                {subItem.name}
              </a>
            </li>
          ))}
        </ul>
      )}
    </li>
  ))}
</ul>


      {open && <div className="mobile-overlay" onClick={() => setOpen(false)} />}
    </header>
  );
}
